import React from 'react';
import PropTypes from 'prop-types';

function Ticket({
  bookLink,
  detailsLink,
  fallbackStatus: {
    showLink: fbShowLink,
    status: fbStatus,
    type: fbType,
  },
  handleMouseEnterTicket,
  handleMouseLeaveTicket,
  handleTouchStartTicket,
  isBlock,
  isDynamicPricing,
  location,
  locationId,
  price,
  ticketmasterStatus: {
    showLink: tmShowLink,
    status: tmStatus,
    statusCode: tmStatusCode,
    useFallback,
  },
  title,
}) {
  const disabled = useFallback ? !fbShowLink : !tmShowLink;

  const getClasses = () => {
    const classesArr = ['c-card__status'];

    if (useFallback) {
      const statusMappings = {
        soldOut: 'c-card__status--sold-out',
        onSale: 'c-card__status--sale',
        sellingFast: 'c-card__status--selling-fast',
        other: 'c-card__status--other',
      };

      const fallbackClass = statusMappings[fbType];
      if (fallbackClass) {
        classesArr.push(fallbackClass);
      }
    } else {
      const tmStatusMappings = {
        TICKETS_NOT_AVAILABLE: 'c-card__status--sold-out',
        TICKETS_AVAILABLE: 'c-card__status--sale',
        FEW_TICKETS_LEFT: 'c-card__status--selling-fast',
        UNKNOWN: 'c-card__status--other',
      };

      const tmStatusClass = tmStatusMappings[tmStatusCode];
      if (tmStatusClass) {
        classesArr.push(tmStatusClass);
      }
    }

    return classesArr.join(' ');
  };

  return (
    <div
      className={`c-card c-card--ticket-shop ${disabled ? 'c-card--ticket-shop-disable' : ''}`}
      data-location={location}
      data-location-id={locationId}
      onMouseEnter={handleMouseEnterTicket}
      onMouseLeave={handleMouseLeaveTicket}
      onTouchStart={handleTouchStartTicket}
    >
      <div className="c-card__content">
        <h3 className="c-card__title">{title}</h3>

        <p className="c-card__meta">
          <span className={getClasses()}>
            {useFallback ? fbStatus : tmStatus}
          </span>
        </p>

        <a
          className="c-text-link"
          href={detailsLink}
        >
          Explore details
        </a>

        {isBlock && (
          <div className="c-card__dynamic-pricing-price u-hide-at-medium">
            {isDynamicPricing && (<span className="c-card__dynamic-pricing-price-from">from</span>)}
            <span>
              $
              {price}
            </span>
          </div>
        )}
      </div>

      {isBlock && (
        <div className="c-card__dynamic-pricing-price u-hide-at-xmedium">
          {isDynamicPricing && (<span className="c-card__dynamic-pricing-price-from">from</span>)}
          <span>
            $
            {price}
          </span>
        </div>
      )}

      <a
        className={`c-card__shop-details ${isBlock ? 'c-card__shop-details--block' : ''}`}
        href={bookLink}
        rel="noreferrer"
        target="_blank"
      >
        <svg><use xlinkHref="#cart" /></svg>

        {!isBlock && (
          <p className="c-card__price">
            {isDynamicPricing && (<span className="c-card__dynamic_pricing">from</span>)}
            $
            {price}
          </p>
        )}

        <span
          className={`c-card__cta c-text-underline c-text-underline--dark c-text-underline--thin ${isDynamicPricing ? 'c-card__cta__dynamic_pricing' : ''}`}
        >
          {disabled ? 'Unavailable' : `Buy ${isBlock ? 'Pass' : ''}`}
        </span>
      </a>
    </div>
  );
}

Ticket.propTypes = {
  bookLink: PropTypes.string.isRequired,
  detailsLink: PropTypes.string.isRequired,
  fallbackStatus: PropTypes.shape({
    showLink: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  handleMouseEnterTicket: PropTypes.func.isRequired,
  handleMouseLeaveTicket: PropTypes.func.isRequired,
  handleTouchStartTicket: PropTypes.func.isRequired,
  isBlock: PropTypes.bool.isRequired,
  isDynamicPricing: PropTypes.bool.isRequired,
  location: PropTypes.string.isRequired,
  locationId: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  ticketmasterStatus: PropTypes.shape({
    showLink: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
    statusCode: PropTypes.string.isRequired,
    useFallback: PropTypes.bool,
  }).isRequired,
  title: PropTypes.string.isRequired,
};

export default Ticket;
